import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaymentAttribute } from '@cashier/cashier-model';

export interface PaymentSnapshotState {
  amount: string | null;
  paymentAttribute: PaymentAttribute | null;
}

export const PAYMENT_SNAPSHOT_FEATURE_KEY = 'paymentSnapshot';

export const initialPaymentSnapshotState: PaymentSnapshotState = {
  amount: null,
  paymentAttribute: null,
};

export const paymentSnapshotSlice = createSlice({
  name: PAYMENT_SNAPSHOT_FEATURE_KEY,
  initialState: initialPaymentSnapshotState,
  reducers: {
    fetchPaymentInformationStart: (state_, __: PayloadAction<string>) =>
      undefined,
    fetchPaymentInformationSuccess: (
      state,
      action: PayloadAction<PaymentAttribute>,
    ) => {
      state.paymentAttribute = action.payload;
    },
    fetchPaymentInformationFailure: (_, __: PayloadAction<any>) => undefined,
    fetchPaymentCurrentStateStart: (_, __: PayloadAction<string>) => undefined,
    fetchPaymentCurrentStateSuccess: (
      state,
      action: PayloadAction<PaymentAttribute>,
    ) => {
      state.paymentAttribute = action.payload;
    },
    initiatePaymentSnapshot: (state, action: PayloadAction<string>) => {
      state.paymentAttribute = initialPaymentSnapshotState.paymentAttribute;
      state.amount = action.payload;
    },
    initiateNewTransaction: () => undefined,
  },
});

export const paymentSnapshotReducer = paymentSnapshotSlice.reducer;

export const {
  fetchPaymentInformationStart,
  fetchPaymentInformationSuccess,
  fetchPaymentInformationFailure,
  fetchPaymentCurrentStateStart,
  fetchPaymentCurrentStateSuccess,
  initiatePaymentSnapshot,
  initiateNewTransaction,
} = paymentSnapshotSlice.actions;
